import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthLayout from "../../layouts/authLayout";
import TextInput from "../../components/inputs/textInput";
import PasswordInput from "../../components/inputs/passwordInput";
import PrimaryButton from "../../components/inputs/PrimaryButton";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";

import { dataCollectionApiBaseUrl } from "../../config/api";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  const login = (e) => {
    e.preventDefault();
    setError("");
    if (!email?.trim() || !password) {
      setError("Email and password are required.");
      return;
    }
    setSubmitting(true);
    axios
      .post(`${dataCollectionApiBaseUrl}/api/auth/login`, {
        email: email.trim().toLowerCase(),
        password,
      })
      .then((res) => {
        if (res.data?.success && res.data?.token) {
          // Update AuthContext state (also stores in localStorage)
          authLogin(res.data.token, res.data.user);
          navigate("/dashboard", { replace: true });
        } else {
          setError("Login failed. Please try again.");
        }
      })
      .catch((err) => {
        const msg = err.response?.data?.message || "Invalid email or password.";
        setError(msg);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <AuthLayout>
      <div className="mb-8">
        <h2 className="text-3xl font-semibold mb-1">
          Welcome EYES Gh Admin
        </h2>
        <p className="text-sm text-gray-600">
          Youth Registration Platform
        </p>
      </div>

      <form onSubmit={login}>
        <TextInput
          label="Email"
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <PasswordInput
          label="Password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <div className="flex items-center justify-between text-sm mb-6">
          <label className="flex items-center gap-2 text-gray-600">
            <input type="checkbox" className="accent-green-900" />
            Keep me signed in
          </label>
          <button type="button" className="text-gray-600 hover:underline">
            Forgot password?
          </button>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
            {error}
          </div>
        )}

        <PrimaryButton type="submit" disabled={submitting}>
          {submitting ? "Signing in…" : "Sign In"}
        </PrimaryButton>
      </form>

      <p className="text-center text-xs text-gray-500 mt-6">
        EYES Ghana Program. Secure Admin Access
      </p>
    </AuthLayout>
  );
};

export default Login;
